import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const WPCallback = () => {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');

    if (token && userStr) {
      try {
        const user = JSON.parse(decodeURIComponent(userStr));
        login(token, user);

        // Redirect based on role
        switch (user.role) {
          case 'admin': navigate('/dashboard'); break;
          case 'student': navigate('/student'); break;
          case 'patient': navigate('/patient'); break;
          case 'healer': navigate('/healer'); break;
          default: navigate('/general');
        }
      } catch (error) {
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [searchParams, login, navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.inner}>
        <img
          src={process.env.REACT_APP_CENTRE_LOGO_URL}
          alt={process.env.REACT_APP_CENTRE_NAME}
          style={styles.logo}
        />
        <div style={styles.text}>Signing you in...</div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #071e12 0%, #0c2617 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  inner: { textAlign: 'center' },
  logo: { height: '52px', margin: '0 auto 20px' },
  text: {
    fontFamily: "'Raleway', sans-serif", fontSize: '13px',
    fontWeight: '700', letterSpacing: '2px',
    textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)'
  }
};

export default WPCallback;